var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-account" }, [
    _c("h1", [_vm._v("Forgot")]),
    !_vm.success
      ? _c(
          "form",
          {
            directives: [
              {
                name: "disable-all",
                rawName: "v-disable-all",
                value: _vm.under18,
                expression: "under18"
              }
            ],
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
                class: _vm.v$.email.$error ? "has_error" : ""
              },
              [
                _c("label", { attrs: { for: "user_email" } }, [
                  _vm._v("Email (Required)")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  attrs: {
                    type: "email",
                    name: "email",
                    id: "user_email",
                    "aria-describedby": "user_email_error"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _c(
                  "span",
                  { attrs: { "aria-live": "polite" } },
                  _vm._l(_vm.v$.email.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { id: "user_email_error" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  }),
                  0
                )
              ]
            ),
            _c("div", { staticClass: "row two-cols" }, [
              _c(
                "div",
                { class: _vm.v$.birth_month.$error ? "has_error" : "" },
                [
                  _c("label", { attrs: { for: "user_birth_month" } }, [
                    _vm._v("Birth Month (MM) (Required)")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.birth_month,
                        expression: "birth_month"
                      }
                    ],
                    attrs: {
                      type: "number",
                      maxlength: "2",
                      name: "birth_month",
                      id: "user_birth_month",
                      "aria-describedby": "user_birth_month_error"
                    },
                    domProps: { value: _vm.birth_month },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.birth_month = $event.target.value
                      }
                    }
                  }),
                  _vm._l(_vm.v$.birth_month.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { role: "status", id: "user_birth_month_error" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  })
                ],
                2
              ),
              _c(
                "div",
                { class: _vm.v$.birth_year.$error ? "has_error" : "" },
                [
                  _c("label", { attrs: { for: "user_birth_year" } }, [
                    _vm._v("Birth Year (YYYY) (Required)")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.birth_year,
                        expression: "birth_year"
                      }
                    ],
                    attrs: {
                      type: "number",
                      name: "birth_year",
                      id: "user_birth_year",
                      "aria-describedby": "user_birth_year_error"
                    },
                    domProps: { value: _vm.birth_year },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.birth_year = $event.target.value
                      }
                    }
                  }),
                  _vm._l(_vm.v$.birth_year.$errors, function(error) {
                    return _c("p", {
                      key: error.$uid,
                      staticClass: "error",
                      attrs: { role: "status", id: "user_birth_year_error" },
                      domProps: { innerHTML: _vm._s(error.$message) }
                    })
                  })
                ],
                2
              )
            ]),
            _vm.under18
              ? _c("div", { staticClass: "btn" }, [
                  _vm._v(
                    "Sorry, you are not eligible to register at this time."
                  )
                ])
              : _vm._e(),
            !_vm.under18
              ? _c("div", { staticClass: "row" }, [
                  _c("input", {
                    staticClass: "btn--primary",
                    attrs: { type: "submit", value: "Reset" }
                  })
                ])
              : _vm._e(),
            _c("div", { staticClass: "row link" }, [
              _vm._v("Don't have an account? "),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$parent.setPage("signup")
                    }
                  }
                },
                [_vm._v("Sign up here")]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm.success
      ? _c("div", { attrs: { "aria-live": "polite" } }, [
          _vm._v("Email has been successfully sent!")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }